import Loadmore from './loadmore.vue'
export default Loadmore



// WEBPACK FOOTER //
// ./src/components/loadmore/index.js